import React, { useContext, useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import AuthContext from '../../../authentication/AuthContext';
import { useAlert } from 'react-alert';
import UserContext from '../../../user/UserContext';
import { handlePresellError } from '../AlertUtils';

export default function DeliveryWindow(props) {
    const { userDetails } = useContext(UserContext);
    const cas = useContext(AuthContext);
    const alert = useAlert();
    let versionNumber = 0;
    let [quantity, setQuantity] = useState(props.quantity);

    let decreaseQuantity = () => {
        if (quantity >= 1) {
            updateQuantity(parseInt(quantity) - 1);
        }
    };

    let increaseQuantity = () => {
        updateQuantity(parseInt(quantity) + 1);
    };

    function updateQuantity(newQuantity) {
        setQuantity(isNaN(newQuantity) ? 0 : parseInt(newQuantity));
        if (userDetails && userDetails.currentFranchise) {
            versionNumber += 1;
            axios
                .post(
                    window.CONFIG['ws.activoc-presell-public.orders.update.product'],
                    {
                        'versionNumber': versionNumber,
                        'deliveryWindowId': props.id,
                        'quantity': newQuantity
                    },
                    {
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json',
                            'x-franchise-code': userDetails.currentFranchise.code
                        }
                    }
                )
                .then(response => {
                    if (response.data.versionNumber === versionNumber) {
                        props.updateQuantities({
                            quantity: newQuantity,
                            deliveryWindowId: props.id,
                            message: response.data.message,
                            status: response.data.status
                        });
                    }
                })
                .catch(error => {
                    handlePresellError(alert, error, 'Could not amend quantity.');
                    axios
                        .get(
                            window.CONFIG['ws.activoc-presell-public.orders.deliveryWindow.qty'].replace('{deliveryWindowId}', props.id),
                            {
                                headers: {
                                    Authorization: cas,
                                    'Content-Type': 'application/json',
                                    'x-franchise-code': userDetails.currentFranchise.code
                                }
                            }
                        )
                        .then(response => {
                            setQuantity(parseInt(response.data));
                        })
                        .catch(e => {
                            handlePresellError(alert, error, 'Could not verify product quantity, please refresh the page.');
                        });
                });
        } else {
            handlePresellError(alert, null, 'Could not amend quantity. Unable to determine current franchise.');
        }
    }

    return (
        <>
            <td className={'delivery-window-cell'}
                data-testid={'delivery-window-cell-' + [props.id]}>
                {!props.orderingTimeFinished &&
                <Button
                    disabled={props.minDisabled}
                    onClick={decreaseQuantity}
                    data-testid={'delivery-window-cell-minus-' + [props.id]}>
                    <FontAwesomeIcon icon={faMinusCircle}/>
                </Button>}
                <FormControl
                    data-testid={'delivery-window-cell-text-box-' + [props.id]}
                    type={'text'}
                    maxLength={'3'}
                    readOnly={props.orderingTimeFinished}
                    size={'3'}
                    value={quantity}
                    onChange={event => {
                        setQuantity(event.target.value);
                    }}
                    onBlur={event => {
                        !props.orderingTimeFinished && updateQuantity(quantity);
                    }}
                    className={'quantity-highlight'}
                />
                {!props.orderingTimeFinished &&
                <Button
                    disabled={props.maxDisabled}
                    onClick={increaseQuantity}
                    data-testid={'delivery-window-cell-plus-' + [props.id]}>
                    <FontAwesomeIcon icon={faPlusCircle}/>
                </Button>
                }
            </td>
        </>
    );
}
